<template>
  <div>
    <div v-if="loginfalse = true" class="col-md-12">
      <form id="loginForm" class="login-form" @submit="checkForm">
        <div class="form-group">
          <div class="partition-title">
            {{ $t('account.label.login_to_your_account') }}
          </div>
          <label for="login">{{ $t('account.label.email') }}:</label>
          <input
            id="login"
            v-model="model.login"
            type="email"
            class="form-control"
            :placeholder="$t('account.placeholder.email')"
            name="login"
            autocomplete="off"
          />
          <div
            v-if="state.login"
            class="help has-error error form-text text-danger"
          >
            <div class="error__message">
              <i class="fas fa-exclamation-triangle"></i>
              {{ state.login }}
            </div>
          </div>
        </div>
        <div class="form-group">
          <label for="password">{{ $t('account.label.password') }}:</label>
          <input
            id="password"
            v-model="model.password"
            type="password"
            class="form-control"
            placeholder="********"
            name="password"
            autocomplete="off"
          />
          <div
            v-if="state.password"
            class="help has-error error form-text text-danger"
          >
            <div class="error__message">
              <i class="fas fa-exclamation-triangle"></i>
              {{ state.password }}
            </div>
          </div>
        </div>
        <div class="reset-password">
          <a href="/password/reset">Pamiršote slaptažodį</a>
        </div>
        <div
          v-if="
            state.auth_status &&
            (!state.login || !state.password) &&
            !state.loggedIn
          "
          class="help has-error error form-text text-danger error-block"
        >
          <div class="error__message">
            <i class="fas fa-exclamation-triangle"></i>
            {{ state.auth_msg }}
          </div>
        </div>
        <button type="submit" class="btn btn-primary blue-fill-in">
          {{ $t('account.button.login') }}
        </button>
      </form>
    </div>
  </div>
</template>

<script>
export default {
  title: '',
  name: 'LoginForm',
  props: {},
  data() {
    return {
      status: false,
      state: {
        login: '',
        password: '',
        auth_status: '',
        auth_msg: '',
        loggedIn: false,
      },
      errors: [],
    }
  },
  computed: {
    model() {
      return this.$store.getters['dataAuth']
    },
  },
  methods: {
    checkForm: function (e) {
      this.errors = []
      e.preventDefault()
      this.state.auth_status = ''
      this.state.auth_msg = ''

      if (!this.model.login) {
        this.state.login = this.$t('account.validation.login-required')
      }

      if (!this.model.password) {
        this.state.password = this.$t('account.validation.password-required')
      }

      if (this.model.login && this.model.password) {
        this.state.login = ''
        this.state.password = ''

        this.$store
          .dispatch('login')
          .then((response) => {
            let status = response.data.status
            this.state.auth_status = response.data.status
            this.state.auth_msg = response.data.msg
            if (status == 'success') {
              this.state.loggedIn = true
              this.$store.dispatch('attempt', response.data.access_token)
              this.$nextTick(() => {
                window.location.reload()
              })
            }
          })
          .catch((error) => {
            this.errors = error.response.data.errors
          })
      }
      e.preventDefault()
    },
  },
}
</script>
